import { render, staticRenderFns } from "./CheckExaminationPaper.vue?vue&type=template&id=40453975&"
import script from "./CheckExaminationPaper.vue?vue&type=script&lang=js&"
export * from "./CheckExaminationPaper.vue?vue&type=script&lang=js&"
import style0 from "./CheckExaminationPaper.vue?vue&type=style&index=0&id=40453975&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports